var _classCallCheck = require("/root/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var WPGHtmlBlock = /*#__PURE__*/function (_React$Component) {
  "use strict";

  _inherits(WPGHtmlBlock, _React$Component);

  var _super = _createSuper(WPGHtmlBlock);

  function WPGHtmlBlock() {
    var _this;

    _classCallCheck(this, WPGHtmlBlock);

    _this = _super.apply(this, arguments);
    _this.id = Math.floor(Math.random() * 100000);
    return _this;
  }

  _createClass(WPGHtmlBlock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.querySelectorAll("[data-script=\"".concat(this.id, "\"]")).forEach(function (script) {
        window.eval(script.innerHTML);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var innerHTML = this.props.innerHTML;
      var scriptHtml = innerHTML.replace(/<script(>|\s)/gm, "<script data-script=\"".concat(this.id, "\"$1"));
      return React.createElement("div", {
        className: "wpg-block wpg-b_html",
        dangerouslySetInnerHTML: {
          __html: scriptHtml
        }
      });
    }
  }]);

  return WPGHtmlBlock;
}(React.Component);

exports.default = WPGHtmlBlock;